<template>
  <v-container v-show="articles && articles.length !== 0">
    <header class="articles-header">
      <h2>News, Press Releases, Etc.</h2>
    </header>

    <v-scroll-y-transition
      group
      mode="out-in"
      class="articles">
      <router-link
        v-for="article in limitedArticles"
        :key="article.slug"
        v-ripple
        :to="{
          name: 'article',
          params: {
            slug: article.slug
          }
        }"
        tag="div"
        :style="`background-image: url(${imageDir + article.coverImage})`"
        class="article">
        <h1
          v-if="article.title"
          class="article__title">
          {{ article.title }}
        </h1>
        <h2
          v-if="article.subtitle"
          class="article__subtitle">
          {{ article.subtitle }}
        </h2>
        <h3 class="article__date">{{ moment(article.dateCreated).format('MMMM Do YYYY') }}</h3>
      </router-link>
    </v-scroll-y-transition>

    <footer class="articles-footer">
      <v-btn
        large
        outline
        :to="{name: 'articles'}"
        class="articles-footer__button">
        read more stuff
      </v-btn>
    </footer>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'LatestNews',
  data() {
    return {
      limit: 4,
    };
  },
  computed: {
    ...mapState('articles', {
      articles: 'articles',
      imageDir: 'imageDir',
      loading: 'loading',
      errorMessage: 'errorMessage',
    }),
    limitedArticles() {
      return this.articles.slice(0, this.limit);
    },
  },
  created() {
    this.$store.dispatch('articles/getAllArticles');
  },
};
</script>

<style lang="stylus" scoped>
@require('../../stylus/base')

.articles-header
  display: flex
  align-items: center
  justify-content: center
  width: 100%
  padding: $base-padding*2

.no-data
  font-family: cursive
  color: $accent

.articles
  width: 100%
  display: flex
  flex-flow: row wrap
  align-items: stretch
  justify-content: space-between

.article
  margin: $base-padding
  position: relative
  min-height: 12rem
  display: flex
  flex: 1 1 40%
  min-width: 16rem
  flex-flow: column nowrap
  align-items: flex-start
  justify-content: center
  padding: $base-padding*2
  color: $secondary
  cursor: pointer
  transition: $base-transition
  border-radius: $base-border-radius

  background-position: center center
  background-size: cover
  background-repeat: no-repeat
  background-color: rgba(6,9,15, .8);
  background-blend-mode: multiply;
  &:hover
    background-color: $primary

  &__title,
  &__subtitle,
  &__date
    color: $white
    opacity: .95
    text-shadow: $base-box-shadow

  &__title
    font-size: 1.75rem
  &__subtitle
    font-size: 1.25rem
    font-weight: 300
  &__date
    padding-top: $base-padding
    font-size: $font-size--small
    font-style: italic
    opacity: .75

.articles-footer
  display: flex
  flex-flow: column nowrap
  align-items: center
  padding: $base-padding
  &__button
    width: 25%
    @media screen and (max-width: 48rem)
      width: 100%

</style>
